'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherMessageCircle } from '@subframe/core';
import { useEffect, useRef } from 'react';
import { Avatar, Badge } from '@/shared/components/ui';
import { ChatInput } from '@/shared/components/ui/common/ChatInput';
import { ChatMessage } from '@/shared/components/ui/common/ChatMessage';
import type { UseNegociacaoSelfReturn } from '../hooks';
import { formatarValorParametro } from '../utils/parametrosCampos';
import { ResumoLinhaEntreExtremos } from './ResumoLinha';
import { WizardFooter } from './WizardFooter';
import { WizardProgressHeader } from './WizardProgressHeader';
interface RevisaoScreenProps {
  vm: UseNegociacaoSelfReturn;
}
export const RevisaoScreen = t0 => {
  const $ = _c(72);
  const {
    vm
  } = t0;
  const finalMensagensRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      finalMensagensRef.current?.scrollIntoView({
        behavior: "smooth"
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vm.chatMensagens || $[2] !== vm.lexiDigitando) {
    t2 = [vm.chatMensagens, vm.lexiDigitando];
    $[1] = vm.chatMensagens;
    $[2] = vm.lexiDigitando;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== vm.wizardSteps) {
    t3 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[4] = vm.wizardSteps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><h1 className="text-heading-dark mb-2 text-2xl font-semibold sm:text-[28px]">É assim que a Lexi vai negociar?</h1><p className="text-label-muted text-[15px] leading-relaxed">Revise o que você configurou e converse com ela antes de ativar. Testar agora é opcional.</p></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-xs text-neutral-500">Usuário</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== vm.perfil.nome) {
    t6 = <span className="text-heading-dark text-sm font-semibold">{vm.perfil.nome}</span>;
    $[8] = vm.perfil.nome;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== vm.perfil.email) {
    t7 = <span className="text-label-muted text-[13px]">{vm.perfil.email}</span>;
    $[10] = vm.perfil.email;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="flex flex-col gap-1 border-t border-solid border-neutral-200 pt-4">{t5}{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-xs text-neutral-500">Empresa</span>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== vm.perfil.nomeFantasia) {
    t10 = <span className="text-heading-dark text-sm font-semibold">{vm.perfil.nomeFantasia}</span>;
    $[16] = vm.perfil.nomeFantasia;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== vm.perfil.razaoSocial) {
    t11 = <span className="text-label-muted text-[13px]">{vm.perfil.razaoSocial}</span>;
    $[18] = vm.perfil.razaoSocial;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== vm.perfil.site) {
    t12 = <span className="text-label-muted text-[13px]">{vm.perfil.site}</span>;
    $[20] = vm.perfil.site;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== vm.perfil.sobre) {
    t13 = <span className="text-label-muted line-clamp-4 text-[13px]">{vm.perfil.sobre}</span>;
    $[22] = vm.perfil.sobre;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13) {
    t14 = <div className="flex flex-col gap-1 border-t border-solid border-neutral-200 pt-4">{t9}{t10}{t11}{t12}{t13}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="text-xs text-neutral-500">Parâmetros</span>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== vm.objetivoLabel) {
    t16 = <ResumoLinhaEntreExtremos rotulo="Objetivo" valor={<Badge variant="brand">{vm.objetivoLabel}</Badge>} />;
    $[30] = vm.objetivoLabel;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== vm.camposObjetivo || $[33] !== vm.valoresParametros) {
    let t18;
    if ($[35] !== vm.valoresParametros) {
      t18 = campo => <ResumoLinhaEntreExtremos key={campo.key} rotulo={campo.label} valor={formatarValorParametro(campo, vm.valoresParametros[campo.key])} />;
      $[35] = vm.valoresParametros;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    t17 = vm.camposObjetivo.map(t18);
    $[32] = vm.camposObjetivo;
    $[33] = vm.valoresParametros;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[37] !== t16 || $[38] !== t17) {
    t18 = <div className="flex flex-col gap-2.5 border-t border-solid border-neutral-200 pt-4">{t15}{t16}{t17}</div>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t14 || $[41] !== t18 || $[42] !== t8) {
    t19 = <div className="flex flex-col gap-6">{t4}{t8}{t14}{t18}</div>;
    $[40] = t14;
    $[41] = t18;
    $[42] = t8;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex items-center gap-2.5 border-b border-solid border-neutral-200 px-5 py-3.5"><FeatherMessageCircle className="text-heading-dark" /><span className="text-heading-dark text-sm font-semibold">Teste a Lexi ao vivo</span><Badge variant="brand">Simulação</Badge></div>;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== vm.chatMensagens) {
    t21 = vm.chatMensagens.map(_temp);
    $[45] = vm.chatMensagens;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== vm.lexiDigitando) {
    t22 = vm.lexiDigitando && <div className="flex items-center gap-1.5 rounded-2xl rounded-tl-none border border-neutral-100 bg-white px-4 py-3.5 shadow-sm"><span className="bg-brand-600 h-1.5 w-1.5 animate-bounce rounded-full" /><span className="bg-brand-600 h-1.5 w-1.5 animate-bounce rounded-full [animation-delay:0.15s]" /><span className="bg-brand-600 h-1.5 w-1.5 animate-bounce rounded-full [animation-delay:0.3s]" /></div>;
    $[47] = vm.lexiDigitando;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div ref={finalMensagensRef} />;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t21 || $[51] !== t22) {
    t24 = <div className="flex flex-1 flex-col gap-3 overflow-y-auto p-5">{t21}{t22}{t23}</div>;
    $[50] = t21;
    $[51] = t22;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== vm) {
    t25 = event => vm.definirChatInput(event.target.value);
    $[53] = vm;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t25 || $[56] !== vm.chatInput || $[57] !== vm.enviarMensagem || $[58] !== vm.lexiDigitando) {
    t26 = <ChatInput placeholder="Digite uma mensagem..." value={vm.chatInput} onChange={t25} onSend={vm.enviarMensagem} isLoading={vm.lexiDigitando} />;
    $[55] = t25;
    $[56] = vm.chatInput;
    $[57] = vm.enviarMensagem;
    $[58] = vm.lexiDigitando;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t24 || $[61] !== t26) {
    t27 = <div className="flex h-[480px] w-full flex-col overflow-hidden rounded-[16px] border border-solid border-neutral-200 sm:h-[560px]">{t20}{t24}{t26}</div>;
    $[60] = t24;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t19 || $[64] !== t27) {
    t28 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-14"><div className="grid w-full max-w-[1280px] grid-cols-1 items-start gap-10 lg:grid-cols-[minmax(300px,1fr)_minmax(420px,1.7fr)] lg:gap-14">{t19}{t27}</div></div>;
    $[63] = t19;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== vm) {
    t29 = <WizardFooter onVoltar={() => vm.goTo(vm.stepAnteriorRevisao)} onAvancar={() => vm.goTo("pagamento")} />;
    $[66] = vm;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t28 || $[69] !== t29 || $[70] !== t3) {
    t30 = <div className="flex min-h-screen w-full flex-col bg-white">{t3}{t28}{t29}</div>;
    $[68] = t28;
    $[69] = t29;
    $[70] = t3;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  return t30;
};
function _temp(mensagem) {
  return <ChatMessage key={mensagem.id} message={mensagem.texto} isUser={mensagem.autor === "user"} avatar={<Avatar variant="brand" size="small">L</Avatar>} />;
}